import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, LowerCasePipe } from '@angular/common';
import { DropdownModule } from './modules/dropdown/dropdown';
// Components
import { LoaderComponent } from './loader/loader.component';
import { RouterModule } from '@angular/router';
import { CssLoaderService } from './services/cssloader.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterPipe } from './pipes/filterBy.pipe';
import { UnescapePipe } from './pipes/htmlUnescape.pipe';
import { FormatFileSizePipe } from './pipes/byte.pipe';
import { NotificationsService } from './services/notifications.service';
import { ToastModule } from '@projects/shared/src/app/modules/toast/toast';
import { TranslateModule } from '@ngx-translate/core';
import { I18nService } from '@app/core';
import { RealTimeNotificationService } from './services/realTimeNotification/real-time-notification.service';
import { ClickOutside } from './directive/menu.directive';
import { DocumentClickDirective } from './directive/document-click.directive';
import { DigitOnlyDirective } from './directive/digit-only.directive';
import { ReflecxColumnDirective } from './directive/reflecx-column.directive';
import { NgxPermissionsModule } from 'ngx-permissions';
import { GooglePlaceModule } from './modules/google-map-autocomplete/ngx-google-places-autocomplete.module';
import { AppConfigurationService } from './services/app.configuration.service';
import { CacheService } from './services/cache.service';
import { AuthServiceCleaner } from './services/auth.service.cleaner';
import { RDatePipe } from './pipes/rdate.pipe';
import { CustomDateFormatPipe } from './pipes/customdateformat.pipe';
import { RequestCache } from '@app/core/http/request.cache.service';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { ProgressBarComponent } from './components/progressbar/progressbar.component';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { ConfirmationService, MessageService } from './modules/config';
import { TableModule } from './modules/table/table.module';
import { PredectiveSearchComponent } from './modules/predective-search/predective-search.component';
import { WidgetsModule } from './modules/widgets/widgets.module';
import { PaginationModule } from './modules/pagination/pagination.module';
import { LeftSideBarComponent } from './components/side-bar/left-side-bar/left-side-bar.component';
import { RightSideBarComponent } from './components/side-bar/right-side-bar/right-side-bar.component';
import { StepsModule } from './modules/steps/steps';
import { TooltipModule } from './modules/tooltip/tooltip';
import { RecentactivityTableComponent } from './components/recent-activity-table/recent-activity-table.component';
import { RecentcallTableComponent } from './components/recent-call-table/recent-call-table.component';
import { SalesTableComponent } from './components/sales-table/sales-table.component';
import { DialPadComponent } from './components/dial-pad/dial-pad.component';
import { DialScreenComponent } from './components/dial-input/dial-input.component';
import { CallActionsComponent } from './components/call-actions/call-actions.component';
import { RecentActivityGridComponent } from './components/recent-activity-grid/recent-activity-grid.component';
import { ContactInfoComponent } from './components/contact-info/contact-info.component';
import { OnGoingCallComponent } from './components/on-going-call/on-going-call.component';
import { LayoutService } from './services/layout.service';
import { CallService } from './services/call.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MultiSelectModule } from './modules/multiselect/multiselect';
import { TelephonyProviderModule } from './providers/telephony/telephony.provider.module';
import { TabsComponent } from './components/tabs/tabs.component';
import { CallFeedbackComponent } from './components/call-feedback/call-feedback.component';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { VerbiageComponent } from './components/veribiage/verbiage.component';
import { NotesComponent } from './components/notes/notes.component';
import { PredictiveSearchFilterComponent } from './modules/predictive-search-filter/predictive-search-filter.component';
import { CalendarModule } from './modules/calendar/calendar';
import { AdvanceCalendarComponent } from './components/advance-calendar/advance-calendar.component';
// import { AdvanceDateRangePickerComponent } from './components/advance-daterangepicker/advance-daterangepicker.component';
import { IncomingCallComponent } from './components/incoming-call/incoming-call.component';
import { CallbackTableComponent } from './components/callback-table/callback-table.component';
import { TimerComponent } from './components/timer/timer.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { SingleCalendarComponent } from './components/single-calendar/single-calendar.component';
import { FlecxModalComponent } from './components/flecx-modal/flecx-modal.component';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { NgxDaterangepickerMd } from './modules/daterangepicker';
import { VirtualScrollerModule } from './modules/virtual-scroller/virtual-scroller';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { MentionModule } from 'angular-mentions';
import { ChatDashboardComponent } from './features/chat/components/chat-dashboard/chat-dashboard.component';
import { VocCustomDropdownComponent } from './components/voc-custom-dropdown/voc-custom-dropdown.component';
import { VocFiltersComponent } from './components/voc-filters/voc-filters.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PgeCustomerSearchModalComponent } from './components/pge-customer-search-modal/pge-customer-search-modal.component';
import { CxDatagridModule } from './modules/cx-datagrid/cx-datagrid.module';
import { CxAdvFiltersModule } from './modules/cx-adv-filters/cx-adv-filters.module';
import { CxSchedularModule } from './modules/cx-schedular/cx-schedular.module';
import { RadioButtonModule } from './modules/radio/radio';
import { ChipsModule } from './modules/chips/chips';
import { AdvanceDateRangeModule } from './components/advance-daterangepicker/advance-daterangepicker.module';
import { RightSideDrawerComponent } from './components/side-bar/right-side-drawer/right-side-drawer.component';
import { LeadPreviewModalComponent } from './components/lead-preview-modal/lead-preview-modal.component';
import { CallbackFieldCurtainComponent } from './components/callback-field-curtain/callback-field-curtain.component';
import { MeetingScheduleComponent } from './features/lead/meeting-schedule/meeting-schedule.component';
import { CampaignUpdateModalComponent } from './components/campaign-update-modal/campaign-update-modal.component';
import { TimezoneClockModalComponent } from './components/timezone-clock-modal/timezone-clock-modal.component';
import { TreeComponent } from './components/tree-checkbox/tree/tree.component';
import { TreeNodeComponent } from './components/tree-checkbox/tree-node/tree-node.component';
import { LeadsAssignedModalComponent } from './components/leads-assigned-modal/leads-assigned-modal.component';
import { PriorityUpdateModalComponent } from './components/priority-update-modal/priority-update-modal.component';
import { BulkCampaignUpdateModalComponent } from './components/bulk-campaign-update-modal/bulk-campaign-update-modal.component';
import { UpdateTeamStructureModalComponent } from './components/update-team-structure-modal/update-team-structure-modal.component';
import { AudioVisualizerComponent } from './components/recording-player/audio-visualizer.component';
import { AudioTranscriptComponent } from './components/recording-player/audio-transcript/audio-transcript.component';
import { TimerService } from './services/timer.service';
import { InternetStatusBannerComponent } from './components/internet-status/internet-status-banner.component';
import { CenterSelectionComponent } from './components/center-selection/center-selection.component';
import { CloneUserModalComponent } from './components/clone-user-modal/clone-user-modal.component';
import { UserUpdateNotificationComponent } from './components/user-update-notification/user-update-notification.component';
import { Timer2Component } from './components/timer2/timer2.component';
import { TodayScheduledCallbacksComponent } from './components/today-callback-scheduled/today-scheduled-callbacks.component';
import { AlertBannerComponent } from './components/alert-banner/alert-banner.component';

const maskConfig: Partial<IConfig> = {
  validation: true,
};
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    AdvanceDateRangeModule,
    RadioButtonModule,
    ChipsModule,
    CxDatagridModule,
    CxAdvFiltersModule,
    CxSchedularModule,

    TelephonyProviderModule,
    MultiSelectModule,
    DropdownModule,
    NgScrollbarModule,
    DragDropModule,
    StepsModule,
    TooltipModule,
    WidgetsModule,
    PaginationModule,
    TableModule,
    CalendarModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    TranslateModule,
    GooglePlaceModule,
    VirtualScrollerModule,
    MentionModule,
    NgxPermissionsModule.forChild(),
    NgxDaterangepickerMd.forRoot(),
    NgxMaskModule.forRoot(maskConfig),
    ImageCropperModule,
  ],
  declarations: [
    OnGoingCallComponent,
    AudioVisualizerComponent,
    AudioTranscriptComponent,
    AdvanceCalendarComponent,
    // AdvanceDateRangePickerComponent,
    ContactInfoComponent,
    CallActionsComponent,
    DialPadComponent,
    DialScreenComponent,
    PredectiveSearchComponent,
    SideBarComponent,
    LeftSideBarComponent,
    RightSideBarComponent,
    TopBarComponent,
    ProgressBarComponent,
    ClickOutside,
    DocumentClickDirective,
    DigitOnlyDirective,
    ReflecxColumnDirective,
    LoaderComponent,
    FilterPipe,
    UnescapePipe,
    FormatFileSizePipe,
    RDatePipe,
    CustomDateFormatPipe,
    DigitOnlyDirective,
    RecentactivityTableComponent,
    RecentcallTableComponent,
    SalesTableComponent,
    RecentActivityGridComponent,
    TabsComponent,
    CallFeedbackComponent,
    SearchFilterComponent,
    VerbiageComponent,
    NotesComponent,
    PredictiveSearchFilterComponent,
    IncomingCallComponent,
    CallbackTableComponent,
    TimerComponent,
    Timer2Component,
    SingleCalendarComponent,
    FlecxModalComponent,
    DataGridComponent,
    StarRatingComponent,
    ChatDashboardComponent,
    VocCustomDropdownComponent,
    VocFiltersComponent,
    PgeCustomerSearchModalComponent,
    RightSideDrawerComponent,
    LeadPreviewModalComponent,
    CallbackFieldCurtainComponent,
    MeetingScheduleComponent,
    CampaignUpdateModalComponent,
    PriorityUpdateModalComponent,
    BulkCampaignUpdateModalComponent,
    UpdateTeamStructureModalComponent,
    LeadsAssignedModalComponent,
    TimezoneClockModalComponent,
    TreeNodeComponent,
    TreeComponent,
    InternetStatusBannerComponent,
    CenterSelectionComponent,
    CloneUserModalComponent,
    UserUpdateNotificationComponent,
    TodayScheduledCallbacksComponent,
    AlertBannerComponent
  ],
  exports: [
    AdvanceDateRangeModule,
    CxDatagridModule,
    CxAdvFiltersModule,
    CxSchedularModule,
    RadioButtonModule,
    ChipsModule,

    CalendarModule,
    NgxPermissionsModule,
    TelephonyProviderModule,
    MultiSelectModule,
    DropdownModule,
    StepsModule,
    NgScrollbarModule,
    DragDropModule,
    TooltipModule,
    PaginationModule,
    WidgetsModule,
    PredectiveSearchComponent,
    TableModule,
    AdvanceCalendarComponent,
    // AdvanceDateRangePickerComponent,
    // PredectiveSearchModule,
    ProgressBarComponent,
    OnGoingCallComponent,
    AudioVisualizerComponent,
    SideBarComponent,
    LeftSideBarComponent,
    RightSideBarComponent,
    TopBarComponent,
    LowerCasePipe,
    ClickOutside,
    ToastModule,
    DocumentClickDirective,
    DigitOnlyDirective,
    ReflecxColumnDirective,
    LoaderComponent,
    FilterPipe,
    UnescapePipe,
    FormatFileSizePipe,
    RDatePipe,
    CustomDateFormatPipe,
    DigitOnlyDirective,
    RecentactivityTableComponent,
    RecentcallTableComponent,
    SalesTableComponent,
    RecentActivityGridComponent,
    GooglePlaceModule,
    TabsComponent,
    CallFeedbackComponent,
    SearchFilterComponent,
    PredictiveSearchFilterComponent,
    IncomingCallComponent,
    CallbackTableComponent,
    TimerComponent,
    Timer2Component,
    SingleCalendarComponent,
    FlecxModalComponent,
    DataGridComponent,
    NgxDaterangepickerMd,
    VirtualScrollerModule,
    StarRatingComponent,
    MentionModule,
    ChatDashboardComponent,
    VocCustomDropdownComponent,
    VocFiltersComponent,
    ImageCropperModule,
    PgeCustomerSearchModalComponent,
    RightSideDrawerComponent,
    LeadPreviewModalComponent,
    CallbackFieldCurtainComponent,
    MeetingScheduleComponent,
    CampaignUpdateModalComponent,
    PriorityUpdateModalComponent,
    BulkCampaignUpdateModalComponent,
    UpdateTeamStructureModalComponent,
    LeadsAssignedModalComponent,
    TimezoneClockModalComponent,
    TreeNodeComponent,
    TreeComponent,
    InternetStatusBannerComponent,
    CenterSelectionComponent,
    CloneUserModalComponent,
    UserUpdateNotificationComponent,
    TodayScheduledCallbacksComponent,
    AlertBannerComponent
  ],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [
        // CampaignService,
        CallService,
        LayoutService,
        // NavService,
        RequestCache,
        CssLoaderService,
        NotificationsService,
        //ToastService,
        MessageService,
        ConfirmationService,
        // MessageService,
        // ConfirmationService,
        AppConfigurationService,
        AuthServiceCleaner,
        I18nService,
        CustomDateFormatPipe,
        CacheService,
        RealTimeNotificationService,
        TimerService
      ],
    };
  }
}
